import SaleService from '@/services/API/SaleService'

const initialState = () => {
    return {
        /**
         * @description
         * This variable stores the current transaction's selected type.
         * It can be 'ticket', 'quotation' or 'invoice'
         */
        activeTransactionIndex: 0,
        availableTransactions: SaleService.getTransactionTypes(),
        waitingSupervisorAuth: false,
        forcePrint: false,
        showMenu: false,
        showSearchType: false,
        showInternalCodeSearch: false,
        showMultiSelectSearch: false,

        editMode: false,

        recoveredStorePickup: null,
        recoveredOcNumber: null,

        isEditingDispatchRequest: false,
        editedDispatchRequestNumber: null,

        editingOrigin: null,
        editingStorePickup: null,

    }
}

export default initialState
